import { render, staticRenderFns } from "./AppProductOrdersView.vue?vue&type=template&id=7e38a8ba"
import script from "./AppProductOrdersView.vue?vue&type=script&lang=ts"
export * from "./AppProductOrdersView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports